export default {
  app: { name: 'ProofFleet', offline: 'Sin conexión', queued: 'En cola: {{count}}' },
  login: {
    title: 'Acceso del conductor',
    phone: 'Teléfono',
    pin: 'PIN',
    submit: 'Entrar',
    error: 'Teléfono o PIN incorrecto',
    deviceBlocked: 'Dispositivo no registrado. Contacte a su supervisor.',
    language: 'Idioma',
  },
  policy: {
    title: 'Reglamento de inspecciones',
    version: 'Revisión {{version}}',
    accept: 'He leído y acepto',
    accepting: 'Enviando…',
    required: 'Lea el reglamento de la flota para continuar.',
    changed: 'El reglamento cambió. Lea la revisión vigente.',
  },
  unit: {
    title: 'Seleccione el vehículo',
    scan: 'Escanear el código QR de la puerta',
    manual: 'Elegir de la lista',
    search: 'Número de unidad',
    empty: 'No se encontraron vehículos',
    notRecognized: 'Etiqueta no reconocida',
  },
  briefing: {
    title: 'Defectos abiertos',
    subtitle: 'Reportados antes en este vehículo. Confirme que los ha visto.',
    none: 'Sin defectos abiertos',
    acknowledge: 'Confirmo que los he visto',
    reported: 'Reportado {{date}}',
  },
  inspection: {
    title: 'Inspección',
    progress: '{{done}} de {{total}}',
    ok: 'Correcto',
    defect: 'Defecto',
    skip: 'No aplica',
    photo: 'Tomar foto',
    photoRequired: 'Foto obligatoria',
    retake: 'Repetir foto',
    note: 'Nota',
    value: 'Medición',
    enterValue: 'Ingrese la medición',
    limit: 'Límite: {{value}}{{unit}}',
    verdictOk: 'Dentro del límite',
    verdictWarn: 'Bajo el límite',
    verdictCritical: 'Crítico',
    next: 'Siguiente',
    back: 'Atrás',
    finish: 'Finalizar inspección',
    incomplete: 'Faltan puntos por completar',
    submitting: 'Enviando…',
  },
  done: {
    title: 'Inspección enviada',
    queued: 'Guardada. Se enviará cuando haya conexión',
    verdictPass: 'Sin hallazgos',
    verdictDefects: 'Hallazgos registrados',
    verdictCritical: 'Defecto crítico encontrado',
    notified: 'Se notificó al responsable',
    again: 'Inspeccionar otro vehículo',
  },
  common: {
    retry: 'Reintentar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    loading: 'Cargando…',
    error: 'Algo salió mal',
    logout: 'Salir',
  },
  push: {
    ask: "¿Quiere recibir un aviso cuando su camión tenga un defecto?",
    enable: "Activar notificaciones",
    install:
      'Para recibir avisos en iPhone, añada la app a la pantalla de inicio: Compartir → “Añadir a inicio”.',
    done: "Notificaciones activadas.",
  },
  voice: {
    record: "Grabar una nota de voz",
    stop: "Parar",
    rerecord: "Grabar de nuevo",
    denied: "Acceso al micrófono denegado",
  },
  history: {
    title: "Mis inspecciones",
    openDefects: "Defectos abiertos en mis unidades",
    inspections: "Enviadas",
    empty: "Aún no hay envíos",
    clean: "Sin hallazgos",
    findings: "{{count}} hallazgo(s)",
    critical: "{{count}} crítico(s)",
    back: "Volver a vehículos",
    link: "Historial",
  },
} as const;
